export default function SignupSliderIco3() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.6667 18.6666C28.6667 26.0304 22.6972 31.9999 15.3333 31.9999C7.96953 31.9999 2 26.0304 2 18.6666C2 11.3028 7.96953 5.33327 15.3333 5.33327M15.3333 15.3333V3.66661C15.3333 2.74614 16.0817 1.99119 16.9977 2.08201C24.8735 2.86286 31.1372 9.12637 31.918 17.0023C32.0088 17.9183 31.2538 18.6666 30.3333 18.6666H18.6667C16.8257 18.6666 15.3333 17.1743 15.3333 15.3333Z"
        stroke="#F636A9"
        stroke-width="3.09091"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
